<template>
    <form-accordion
        name="property-type"
        section="Property Type"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <property-commercial
            v-if="broker_is_commercial"
            :property="property"
            :read_only="read_only"
        />

        <property-type
            :property="property"
            :types="property_types"
            :read_only="read_only"
        />

        <property-type-classes
            v-if="property.is_commercial"
            :property="property"
            :types="commercial_type_classes"
            :read_only="read_only"
        />

        <property-type-leed
            v-if="property.is_commercial"
            :property="property"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import PropertyCommercial from './property-commercial.vue';
import PropertyType from './property-type.vue';
import PropertyTypeClasses from './property-type-classes.vue';
import PropertyTypeLeed from './property-type-leed.vue';

export default {
    components: {
        PropertyCommercial,
        PropertyType,
        PropertyTypeClasses,
        PropertyTypeLeed,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        types: { default: () => [] },
        commercial_types: { default: () => [] },
        commercial_type_classes: { default: () => [] },
        broker_is_commercial: { default: false },
        read_only: { default: false },
    },

    computed: {
        property_types() {
            if (this.property.is_commercial) {
                return this.commercial_types;
            }

            if (store.state.tenant === 'ng') {
                return [
                    { label: 'Bungalow, Detached or Semi-Detached', value: 'dt' },
                    { label: 'Townhouse, Duplex or Row House', value: 'at' },
                    { label: 'Apartments', value: '2_4' },
                    { label: 'Commercial Real Estate', value: 'multi' },
                    { label: 'Condominium', value: 'co_op' },
                ];
            }

            return this.types;
        },
    },
}
</script>
